module.exports = __webpack_public_path__ + "media/country_flags/gn-33215bd2.png";